import React from 'react'
import { HamburgerIconDark, HamburgerIconLight } from '../../ui-library/icons';

const HamburgerMenu = ({isDark}) => {
  return <div>{isDark ? <HamburgerIconDark /> : <HamburgerIconLight /> }</div>;
}

export default HamburgerMenu